import View from '@picsart/view/View';
import { PropsWithChildren, ReactNode } from 'react';

import PersistentEditor from '../../../features/PersistenEditor/PersistentEditor';
import { AD_WRITER_CATEGORY, CATEGORIES } from '../../../constants';
import FormContent from '../FormContent';
import Alerts from '../Alerts';
import AdMakerBanner from '../AdMakerBanner/AdmakerBanner';
import Results from '../Results';

import useStyles from './styles';

type MainContentProps = {
  selectedCategory: number;
  heading?: string;
  resultsEditable?: boolean;
  resultsSavedToRecent?: boolean;
  generateButtonKey?: string;
} & PropsWithChildren<ReactNode>;

function MainContent({
  selectedCategory,
  heading,
  children,
  resultsEditable,
  resultsSavedToRecent,
  generateButtonKey,
}: MainContentProps) {
  const classes = useStyles();

  return (
    <View flex={1} gap={60}>
      <View id="qt_main_content" flexDirection="column" flex={1} className={classes.content}>
        <div className={classes.box}>
          <Alerts />
          {selectedCategory === AD_WRITER_CATEGORY && <AdMakerBanner />}

          <h1 className={classes.heading}>{heading || CATEGORIES[selectedCategory].label}</h1>

          <FormContent selectedCategory={selectedCategory} generateButtonKey={generateButtonKey} />

          <Results
            editable={resultsEditable}
            selectedCategory={selectedCategory}
            canBeSavedToRecent={resultsSavedToRecent}
          />
          {children ? children : null}
        </div>
      </View>

      <PersistentEditor />
    </View>
  );
}
export default MainContent;
